// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { useAuth } from 'contexts/AuthContext';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const { isAdmin } = useAuth();

  const filteredItems = menuItem.items.map((item) => {
    if (item.type !== 'group' || !Array.isArray(item.children)) {
      return item;
    }

    const children = item.children.filter((child) => {
      if (child.id === 'admin-users' || child.id === 'dashboard') return isAdmin;
      return true;
    });

    return { ...item, children };
  });

  const navGroups = filteredItems.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 1 }}>{navGroups}</Box>;
}
